import { colones } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { TableCell, TableRow } from "@/components/ui/table";
import { Copy, Trash2, FileDown, FolderOpen } from "lucide-react";

export const CotizacionRow = ({ c, todas, onAbrir, onDuplicar, onPdf, onEliminar, soloAbrir }) => (
  <TableRow data-testid={`cotizacion-row-${c.id}`} className="cursor-pointer" onClick={onAbrir}>
    <TableCell className="font-medium">{c.nombre}</TableCell>
    <TableCell className="hidden sm:table-cell text-muted-foreground text-xs">{c.fecha_creacion ? c.fecha_creacion.slice(0, 10).split("-").reverse().join("/") : ""}</TableCell>
    {todas && <TableCell className="hidden sm:table-cell text-xs">{c.usuario_nombre}</TableCell>}
    <TableCell className="hidden md:table-cell">{c.items?.length || 0} líneas</TableCell>
    <TableCell className="hidden md:table-cell font-semibold">{colones(c.total_mano_obra)}</TableCell>
    <TableCell onClick={(e) => e.stopPropagation()}>
      <div className="flex gap-1">
        <Button data-testid={`abrir-cot-${c.id}`} variant="ghost" size="icon" className="h-7 w-7" title="Abrir" onClick={onAbrir}><FolderOpen size={14} /></Button>
        {!soloAbrir && (
          <>
            <Button data-testid={`duplicar-cot-${c.id}`} variant="ghost" size="icon" className="h-7 w-7" title="Duplicar" onClick={onDuplicar}><Copy size={14} /></Button>
            <Button data-testid={`pdf-cot-${c.id}`} variant="ghost" size="icon" className="h-7 w-7" title="PDF" onClick={onPdf}><FileDown size={14} /></Button>
          </>
        )}
        <Button data-testid={`eliminar-cot-${c.id}`} variant="ghost" size="icon" className="h-7 w-7 text-destructive" title="Eliminar" onClick={onEliminar}><Trash2 size={14} /></Button>
      </div>
    </TableCell>
  </TableRow>
);
